import { AlarmTriggerState, NotificationDelivery } from '../gql/generated';

export const notificationStateVariant: Record<
  AlarmTriggerState,
  'success' | 'error'
> = {
  [AlarmTriggerState.Triggered]: 'error',
  [AlarmTriggerState.Resolved]: 'success',
};

export const notificationStateLabel: Record<AlarmTriggerState, string> = {
  [AlarmTriggerState.Triggered]: 'Active',
  [AlarmTriggerState.Resolved]: 'Resolved',
};

/** A notification timestamp: `03/09/2026, 15:30`, with a swappable separator. */
export function formatNotificationDate(
  value?: string | null,
  separator = ', '
): string {
  if (!value) return '—';

  const date = new Date(value);
  const day = date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  const time = date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
  });
  return `${day}${separator}${time}`;
}

/** A bare en-GB datetime, for stored timestamps like `createdAt`. */
export function formatDateTime(value?: string | null): string | undefined {
  return value ? new Date(value).toLocaleString('en-GB') : undefined;
}

export function formatChannelNames(
  deliveries?: NotificationDelivery[] | null
): string {
  if (!deliveries || deliveries.length === 0) return '';

  return deliveries
    .map((delivery) => delivery.notificationChannelName || 'Unknown')
    .join(', ');
}
